import { render } from "./Image.vue?vue&type=template&id=25457f3f&scoped=true"
import script from "./Image.vue?vue&type=script&lang=ts"
export * from "./Image.vue?vue&type=script&lang=ts"

import "./Image.vue?vue&type=style&index=0&id=25457f3f&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-25457f3f"

export default script